import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	width: 100%;
	padding: 6em 0 0 0;

	.company-background {
		overflow: hidden;
		min-width: 100%;
		max-height: 40em;

		&.blank-background {
			height: 16em;
		}

		.company-background-image {
			width: 100%;
			height: 100%;
			object-fit: cover;
			object-position: top;
		}
		.company-background-container {
			height:40em;
		}
	}

	@media all and (max-width: ${vars.tabletL}) {
		.company-background {
			height: 50em;

			&.blank-background {
				height: 20em;
			}

			.company-background-image {
				height: 100%;
				object-fit: cover;
			}
		}
	}
`;
